<script lang="ts" setup>
import { soundList } from "@/App/services/sound.service";
import { useOptionsStore } from "@/App/options/options.store";

const optionsStore = useOptionsStore();
</script>

<template>
  <div v-for="(option, index) in soundList" :key="option[0]" class="sound-option">
    <input
      :id="option[0]"
      v-model="optionsStore.playSoundForCaseUpdates"
      :value="index"
      :name="option[0]"
      type="radio"
      @change.stop="() => optionsStore.setPlaySoundForCaseUpdates(optionsStore.playSoundForCaseUpdates)"
    />

    <label :for="option[0]">{{ option[0] }}</label>
  </div>
</template>

<style>
.sound-option {
  padding-top: 0.2rem;
}

.sound-option label {
  padding-left: 0.3rem;
}
</style>
